var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterTiles2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 64,
    viewBox: "0 0 1440 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    width: 63,
    height: 64,
    fill: "#43B87A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 122,
    width: 63,
    height: 64,
    fill: "#91814F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 185,
    width: 63,
    height: 64,
    fill: "#B5C6C1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 311,
    width: 63,
    height: 64,
    fill: "#89448B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 374,
    width: 63,
    height: 64,
    fill: "#5B5EBB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 437,
    width: 63,
    height: 64,
    fill: "#84F0F3"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 500,
    width: 63,
    height: 64,
    fill: "#61727A"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 563,
    width: 63,
    height: 64,
    fill: "#799C63"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 689,
    width: 63,
    height: 64,
    fill: "#ED6A11"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 752,
    width: 63,
    height: 64,
    fill: "#595FBB"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 815,
    width: 63,
    height: 64,
    fill: "#47B57A"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 878,
    width: 63,
    height: 64,
    fill: "#028CD7"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 941,
    width: 63,
    height: 64,
    fill: "#B600DC"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 1067,
    width: 63,
    height: 64,
    fill: "#EE8CA0"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 1130,
    width: 63,
    height: 64,
    fill: "#9B3367"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 1193,
    width: 63,
    height: 64,
    fill: "#66515D"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 1319,
    width: 63,
    height: 64,
    fill: "#A5E9B8"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 1382,
    width: 63,
    height: 64,
    fill: "#1558DA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTiles2);
export default __webpack_public_path__ + "static/media/FooterTiles2.286f0e7886f18c4e0ceba64705eb0c33.svg";
export { ForwardRef as ReactComponent };